export const TONES = {
  blue: "from-blue-600 to-sky-400 shadow-blue-500/30",
  green: "from-emerald-600 to-green-400 shadow-emerald-500/30",
  orange: "from-orange-500 to-amber-400 shadow-orange-500/30",
  purple: "from-violet-600 to-fuchsia-400 shadow-violet-500/30",
  red: "from-rose-600 to-red-400 shadow-rose-500/30",
  teal: "from-teal-600 to-cyan-400 shadow-teal-500/30",
};

export const GradientStat = ({ tone = "blue", icon: Icon, label, value, sub, onClick, testid, delay = 0 }) => (
  <button type="button" onClick={onClick} data-testid={testid} style={{ animationDelay: `${delay}ms` }}
    className={`relative overflow-hidden text-left rounded-2xl p-5 text-white bg-gradient-to-br ${TONES[tone]} shadow-lg hover:-translate-y-0.5 hover:shadow-xl transition-[transform,box-shadow] fade-up`}>
    <span className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-white/15" />
    <span className="absolute right-6 -bottom-10 h-20 w-20 rounded-full bg-white/10" />
    <div className="relative flex items-center gap-4">
      <div className="h-12 w-12 rounded-xl bg-white/20 backdrop-blur flex items-center justify-center shrink-0"><Icon className="h-6 w-6" /></div>
      <div className="min-w-0">
        <div className="text-xs font-medium text-white/85">{label}</div>
        <div className="text-2xl font-bold font-display truncate">{value}</div>
        {sub && <div className="text-[11px] text-white/75">{sub}</div>}
      </div>
    </div>
  </button>
);

export const StatPill = ({ tone = "blue", icon: Icon, label, value, onClick, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`shrink-0 inline-flex items-center gap-2 pl-1.5 pr-4 py-1.5 rounded-full text-white text-sm bg-gradient-to-r ${TONES[tone]} shadow-md hover:brightness-105 transition-[filter]`}>
    <span className="h-7 w-7 rounded-full bg-white/25 flex items-center justify-center"><Icon className="h-4 w-4" /></span>
    <span className="font-medium whitespace-nowrap">{label}:</span>
    <b className="whitespace-nowrap">{value}</b>
  </button>
);

export const PageHero = ({ icon: Icon, title, sub, children }) => (
  <div className="rounded-3xl bg-gradient-to-r from-blue-50 via-indigo-50 to-sky-100 border border-blue-100 p-6 mb-6 fade-up">
    <div className="flex items-center gap-4">
      <div className="h-14 w-14 rounded-2xl bg-white shadow-sm flex items-center justify-center"><Icon className="h-7 w-7 text-blue-700" /></div>
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900" data-testid="admin-page-title">{title}</h1>
        {sub && <p className="text-sm text-slate-600 mt-0.5">{sub}</p>}
      </div>
    </div>
    {children && <div className="mt-5 flex flex-wrap gap-3">{children}</div>}
  </div>
);
